<template>
  <div class="dietTreatment">
    <van-row style="padding-bottom: 5px">
      <van-col span="12">
        <span style="color: #8e8c92">开嘱医生：</span>
        <span>{{ doctorName }}</span>
      </van-col>
      <van-col span="12" align="right">
        <span style="color: #8e8c92">科室：</span>
        <span>{{ departmentName }}</span>
      </van-col>
    </van-row>
    <van-form @submit="onSubmit" label-width="60">
      <div class="foodContent">
        <van-row>
          <van-col span="24">
            <span class="title">{{ hospitalName }}</span>
          </van-col>
        </van-row>
        <!-- <van-row>
          <van-col span="5">
            <span class="label">套餐名称</span>
          </van-col>
          <van-col span="19">
            <span>{{ businessPackage.name }}</span>
          </van-col>
        </van-row> -->
        <van-row>
          <van-col span="5">
            <span class="label">套餐天数</span>
          </van-col>
          <van-col span="19">
            <span>{{ therapeuticMeal.length }}天</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="5">
            <span class="label">套餐详情</span>
          </van-col>
          <van-col span="19">
            <span>如下表</span>
          </van-col>
        </van-row>
        <div v-if="therapeuticMeal.length > 0" class="foodTable" style="margin-top: 10px">
          <van-row v-for="(item, index) in therapeuticMeal" :key="item.id" align="center">
            <van-col class="van-col-left" span="4">
              <span>第{{ index + 1 }}天</span>
            </van-col>
            <van-col span="20">
              <span>{{ item.businessName }}</span>
            </van-col>
          </van-row>
        </div>
        <div v-if="businessPackageMeals.length > 0" class="foodTable" style="margin-top: 10px">
          <van-row v-for="item in businessPackageMeals" :key="item.id" align="center">
            <van-col class="van-col-left" span="4">
              <span>{{ item.name }}</span>
            </van-col>
            <van-col span="20">
              <span>{{ item.dishNames }}</span>
            </van-col>
          </van-row>
        </div>
        <!-- <van-row style="padding-bottom: 10px">
          <van-col span="24">
            <span class="label">营养信息</span>
          </van-col>
        </van-row>
        <van-row align="center" class="energy-van-row">
          <van-col span="6">
            <span>能量kcal</span>
          </van-col>
          <van-col span="6">
            <span>碳水化合物g</span>
          </van-col>
          <van-col span="6">
            <span>蛋白质g</span>
          </van-col>
          <van-col span="6">
            <span>脂肪g</span>
          </van-col>
        </van-row> -->
        <!-- <van-row align="center" class="energy-van-row" style="border-top: none">
          <van-col span="6">
            <span>{{ businessPackage.energy }}</span>
          </van-col>
          <van-col span="6">
            <span>{{ businessPackage.carbohydrate }}</span>
          </van-col>
          <van-col span="6">
            <span>{{ businessPackage.protein }}</span>
          </van-col>
          <van-col span="6">
            <span>{{ businessPackage.fat }}</span>
          </van-col>
        </van-row> -->
      </div>
      <!--配送信息 -->
      <div class="distribution">
        <van-row align="center">
          <van-col span="24">
            <span class="label">配送信息</span>
          </van-col>
        </van-row>
        <van-row align="center" v-if="payStatus == true">
          <van-col span="5">
            <span class="label">联系人</span>
          </van-col>
          <van-col span="5">
            <span>{{ infoData.contactUser }}</span>
          </van-col>
        </van-row>
        <van-row align="center" v-else>
          <van-col span="14">
            <van-field label="联系人" :rules="[{ required: true, message: '请填写用户名' }]" v-model="form.contactUser"
              placeholder="请输入联系人" />
          </van-col>
          <van-col span="10">
            <van-radio-group v-model="form.sex" direction="horizontal">
              <van-radio :name="1">先生</van-radio>
              <van-radio :name="0">女士</van-radio>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row align="center" style="margin-top: 15px">
          <van-col span="5">
            <span class="label">电话号码</span>
          </van-col>
          <van-col span="19">
            <span v-if="payStatus == true">{{ infoData.contactPhone }}</span>
            <van-field v-else type="number" :rules="[{ required: true, message: '请填写电话号码' }]" v-model="form.contactPhone"
              placeholder="请输入电话号码" />
          </van-col>
        </van-row>

        <van-row class="time-content" align="center" style="margin-top: 15px; position: relative">
          <!-- <van-col span="5">
            <span class="label">配送日期</span>
          </van-col> -->
          <div style="
              border-bottom: 1px solid #999;
              width: 100%;
              width: 80%;
              position: absolute;
              right: 0;
              z-index: 1;
              bottom: 15%;
            "></div>
          <van-col span="5">
            <span class="label">配送日期</span>
          </van-col>
          <van-col span="19">
            <span v-if="payStatus == true">{{ infoData.reserveDate }}</span>
            <van-cell-group inset v-else>
              <van-cell title="配送日期" :value="form.reserveDate" @click="timeShow = true" />
              <van-calendar :min-date="minDate" v-model:show="timeShow" @confirm="timeConfirm" />
            </van-cell-group>
          </van-col>
        </van-row>
        <van-row class="time-content" align="center">
          <van-col span="5">
            <span class="label"></span>
          </van-col>
          <van-col span="19">
            <span class="label"> 提示:将从配送日期开始连续配送固定天数</span>
          </van-col>
        </van-row>
        <van-row align="center" style="margin-top: 15px">
          <van-col span="5">
            <span class="label">配送地址</span>
          </van-col>
          <van-col span="19">
            <span v-if="payStatus == true">{{ infoData.orgAddress }}</span>
            <van-field v-else :rules="[{ required: true, message: '请填写配送地址' }]" v-model="form.orgAddress"
              placeholder="请输入配送地址" />
          </van-col>
        </van-row>
        <van-row align="center">
          <van-col span="5">
            <span class="label"></span>
          </van-col>
          <van-col span="19">
            <span class="label">提示：请填写院内地址,院外地址不予配送。</span>
          </van-col>
        </van-row>
      </div>
      <div class="remarks-content">
        <van-row align="center" style="padding-left: 10px">
          <van-col span="5">
            <span class="label">备注信息</span>
          </van-col>
        </van-row>
        <van-row style="margin-top: 10px" align="center">
          <van-col span="24">
            <van-cell-group inset v-if="payStatus == true">
              <span>{{ infoData.remark }}</span>
            </van-cell-group>
            <van-cell-group inset v-else>
              <van-field v-model="form.remark" rows="3" autosize type="textarea" placeholder="如有需要请填写" />
            </van-cell-group>
          </van-col>
        </van-row>
      </div>
      <van-row style="margin-top: 20px">
        <van-button type="primary" native-type="submit" block :disabled="payStatus == true">
          <span style="margin-right: 0px">
            ￥{{ businessPayOrderPrice }}
            <span v-if="payStatus == true">已下单</span>
            <span v-else>确认下单</span>
          </span>
        </van-button>
       </van-row>
      <!-- <van-row style="margin-top: 15px" v-if="!orderNo">
        <van-button type="primary" color="#999" native-type="submit" @click="offlineOrder" block>
          <span style="margin-right: 0px"> 创建订单（线下支付） </span>
        </van-button>
      </van-row> -->
    </van-form>
  </div>
</template>
<script>
import {
  dietTreatmentSave,
  dietTreatmentOrderDetails,
  dietTreatmentOrderPay,
} from "@/api/dietaryguidance/dietaryguidance";
import { reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
import { Toast, Dialog } from "vant";

export default {
  setup() {
    const route = useRoute();
    const state = reactive({
      timeShow: false,
      doctorName: '',
      departmentName: '',
      businessPackageMeals: [],
      businessPackage: {},
      businessPayOrderPrice: 0,
      paymentOrderNo: route.query.paymentOrderNo,
      form: {
        reserveDate: "",
        packageIds: [],
        paymentOrderNo: route.query.paymentOrderNo,
        sex: 1,
        createName: route.query.createName,
        departmentName: route.query.deptName,
        departmentCode: route.query.deptCode,
      },
      minDate: null,
      therapeuticMeal: [],
      infoData: {},
      payStatus: undefined
    });
    // 线下支付
    const offlineOrder = () => {
      state.form.payMethod = 2;
    };
    // 最小日期
    const setMinDate = (date) => {
      const TimeDays = 1000 * 60 * 60 * 24;
      const nowTime = date.getTime();
      const minDate = new Date(nowTime + TimeDays);
      console.log(nowTime);
      let month = minDate.getMonth();
      let day = minDate.getDate() - 1 ;
      let year = minDate.getFullYear();
      state.minDate = new Date(year, month, day);
    };
    setMinDate(new Date());
    // 获取详情
    const queryDetails = () => {
      dietTreatmentOrderDetails({ paymentOrderNo: route.query.paymentOrderNo }).then((v) => {
        const { data } = v;
        state.therapeuticMeal = data.businessPayOrders
        state.therapeuticMeal.forEach(value => {
          state.form.packageIds.push(value.businessId)
          state.infoData.contactUser = value.contactUser
          state.infoData.contactPhone = value.contactPhone
          state.infoData.reserveDate = value.reserveDate
          state.infoData.orgAddress = value.orgAddress
          state.infoData.remark = value.remark
          state.infoData.sex = value.sex
        })
        state.businessPayOrderPrice = data.businessPayOrderPrice
        state.doctorName = data.businessPayOrderDoctor.doctorName
        state.departmentName = data.businessPayOrderDoctor.departmentName
        //判断是否支付
        state.payStatus = data.payStatus
      });
    };
    queryDetails();
    // 日期转换
    const formatDate = (date) => {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month < 10) {
        month = `0${date.getMonth() + 1}`;
      }
      if (day < 10) {
        day = `0${date.getDate()}`;
      }

      const monthData = `${date.getFullYear()}-${month}-${day}`;
      return monthData;
    };
    // 日期选择
    const timeConfirm = (value) => {
      state.timeShow = false;
      state.form.reserveDate = formatDate(value);
      console.log(value);
    };
    // 确认下单
    const onSubmit = (value) => {
      if (value) {
        if (!state.form.reserveDate) {
          Toast("请选择配送时间");
          return;
        }
        state.form.contactUser = `${state.form.contactUser}${state.form.sex == 1 ? "先生" : "女士"
          }`;
        if (state.orderNo) {
          console.log(state.orderNo);
          dietTreatmentOrderPay(
            Object.assign({ id: state.orderNo }, state.form)
          ).then((v) => {
            const { data } = v;
            window.location.href = data;
            console.log(data);
          });
        } else {
          dietTreatmentSave(state.form).then((v) => {
            const { data } = v;
            const paymentUrl = data;
            if (state.form.payMethod == 2) {
              Dialog.alert({
                message: data,
              }).then(() => {
                // on close
              });
            } else {
              window.location.href = paymentUrl;
            }
          });
        }
      }
    };
    return {
      onSubmit,
      timeConfirm,
      ...toRefs(state),
      offlineOrder,
    };
  },
};
</script>
<style lang="scss" scoped>
.dietTreatment {
  height: calc(100vh - 20px);
  background: #ededed;
  padding: 10px;

  .van-field {
    padding: 0;

    ::v-deep input {
      border-bottom: 1px solid #999;
    }
  }

  .van-cell-group {
    margin: 0;
  }

  .time-content {
    .van-cell {
      padding: 0;

      ::v-deep .van-cell__title {
        span {
          color: #8e8c92 !important;
        }
      }

      ::v-deep .van-cell__value {
        position: absolute;
        left: 21%;

        span {
          color: initial;
        }
      }
    }

    .van-icon-arrow {
      color: #8e8c92;
    }
  }

  .label {
    color: #8e8c92;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
  }

  .foodContent {
    background: #fff;
    padding: 10px;

    .van-row {
      padding: 2px 0;
    }

    .foodTable {
      .van-row {
        border: 1px solid #999;
        padding: 0;
        border-bottom: none;

        .van-col-left {
          padding: 5px 0;
          border-right: 1px solid #999;
        }

        .van-col {
          padding-left: 10px;
        }
      }

      .van-row:last-of-type {
        border: 1px solid #999;
      }
    }

    .energy-van-row {
      border: 1px solid #999;
      padding: 0;

      .van-col {
        padding: 5px 0;
        border-right: 1px solid #999;
        text-align: center;
      }

      .van-col:last-of-type {
        border: none;
      }
    }
  }

  .distribution {
    padding: 10px;
    margin-top: 10px;
    background: #fff;

    .van-row {
      padding: 5px 0;
    }
  }

  .remarks-content {
    margin-top: 10px;

    .van-field {
      border: none;

      ::v-deep .van-field__control {
        padding-left: 10px;
        padding-top: 10px;
      }
    }
  }

  ::v-deep .van-cell__title {
    color: #8e8c92;
  }
}
</style>
